// Corporate wordmark: E ∞ N on a shared baseline, hairline rule, letterspaced legal lockup. Pure mono.
export const Logo = ({ className = "h-10", stacked = true, dark = false }) => {
  const c = dark ? "#000" : "#fff";
  return (
    <svg viewBox="0 0 300 150" className={`${className} w-auto`} role="img" aria-label="EON Infinity Entertainment LLC" data-testid="brand-logo">
      <text x="0" y="100" fill={c} fontFamily="Oswald, sans-serif" fontWeight="700" fontSize="104">E</text>
      <path d="M78 59 C78 31 112 31 143 59 C174 87 208 87 208 59 C208 31 174 31 143 59 C112 87 78 87 78 59 Z"
        fill="none" stroke={c} strokeWidth="13" strokeLinejoin="round" />
      <text x="232" y="100" fill={c} fontFamily="Oswald, sans-serif" fontWeight="700" fontSize="104">N</text>
      {stacked && (
        <>
          <line x1="0" y1="114" x2="298" y2="114" stroke={c} strokeOpacity="0.45" strokeWidth="1" />
          <text x="0" y="140" fill={c} fontFamily="Oswald, sans-serif" fontWeight="400" fontSize="15.5" textLength="298" lengthAdjust="spacing">INFINITY ENTERTAINMENT LLC</text>
        </>
      )}
    </svg>
  );
};
